// Shows the cookie warning to the user
function showCookieWarning()
{
    $('#cookie_directive_container').show();
    $(document.body).css('padding-bottom', $('#cookie_directive_container').outerHeight(true));
}

// Hides the cookie warning
function hideCookieWarning()
{
    $('#cookie_directive_container').hide();
    $(document.body).css('padding-bottom', 0);
}

// Checks if the cookie has been consented, and show if not
function checkCookieConsent()
{
    if (this.noCookieSet("cookies_consent"))
        this.showCookieWarning();
}

// Checks if the cookie is missing or is 0
function noCookieSet(c_name)
{
    var consent = this.getCookie(c_name);
    if (consent == null || consent == "" || consent == undefined || consent == 0)
        return true
    else
        return false;
}

// Stores a cookie
function setCookie(c_name,value,exdays)
{
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    var c_value = escape(value) + ((exdays==null) ? "" : "; expires="+exdate.toUTCString());
    document.cookie = c_name + "=" + c_value+"; path=/";
    $('#cookie_directive_container').hide('slow');
}

// Gets a cookie
function getCookie(c_name)
{
    var i,x,y,ARRcookies=document.cookie.split(";");
    for (i=0;i<ARRcookies.length;i++)
    {
        x=ARRcookies[i].substr(0,ARRcookies[i].indexOf("="));
        y=ARRcookies[i].substr(ARRcookies[i].indexOf("=")+1);
        x=x.replace(/^\s+|\s+$/g,"");
        if (x==c_name)
        {
            return unescape(y);
        }
    }
}

// Accept the cookies
function acceptCookie()
{
    this.setCookie("cookies_consent", 1, 365);
    this.hideCookieWarning();
}

// Check for cookie on page load
jQuery(window).load(function () {
    // Cookie Stuff
    checkCookieConsent();
});

$( document ).ready(function() {
    // User accepts cookies
    $("#acceptCookiesButton").click(function () {
        acceptCookie();
    });
});